"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("./utils");
var _useColorScheme = require("./_use-color-scheme");
var _usePrefersColorScheme = _interopRequireDefault(require("../use-prefers-color-scheme"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Set the theme. Changes are applied to all the component's descendants.
 */
function Theme(_ref) {
  var palette = _ref.palette,
    mode = _ref.mode,
    tokens = _ref.tokens,
    children = _ref.children;
  var themeContext = (0, _react.useContext)(_utils.ThemeContext);
  var preferredColorScheme = (0, _usePrefersColorScheme["default"])();

  // If `palette` or `mode` is undefined, inherit them from context (or the default).
  // This allows for nesting <Theme>s.
  var themePalette = palette ? (0, _utils.getThemePalette)(palette) : themeContext.palette;
  var themeMode = mode ? mode === "auto" ? preferredColorScheme : mode : themeContext.mode;
  var themeTokens = (0, _utils.resolveTokens)(themePalette, themeMode);
  var currentTokens = (0, _utils.mergeTokens)(themeTokens)(tokens);
  return /*#__PURE__*/_react["default"].createElement(_utils.ThemeContext.Provider, {
    value: {
      palette: themePalette,
      mode: themeMode,
      tokens: currentTokens
    }
  }, /*#__PURE__*/_react["default"].createElement(_useColorScheme.ColorSchemeContext.Provider, {
    value: themeMode
  }, children));
}
Theme.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The components to apply the theme to.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * Use "light" or "dark" to specify the current mode directly, or use "auto" to automatically choose the mode based on the user's system settings.
   */
  mode: _propTypes["default"].oneOf(["auto", "light", "dark"]),
  /**
   * The color palette to apply to the theme, blue is the default.
   * Use the Meridian Theme Creator to create a custom palette.
   */
  palette: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["blue"]), _propTypes["default"].shape({
    _version: _propTypes["default"].string.isRequired,
    _paletteBase: _propTypes["default"].string.isRequired,
    palette50: _propTypes["default"].string.isRequired,
    palette100: _propTypes["default"].string.isRequired,
    palette200: _propTypes["default"].string.isRequired,
    palette300: _propTypes["default"].string.isRequired,
    palette400: _propTypes["default"].string.isRequired,
    palette500: _propTypes["default"].string.isRequired,
    palette600: _propTypes["default"].string.isRequired,
    palette700: _propTypes["default"].string.isRequired,
    palette800: _propTypes["default"].string.isRequired,
    paletteMuted100: _propTypes["default"].string.isRequired,
    paletteMuted200: _propTypes["default"].string.isRequired,
    paletteMuted300: _propTypes["default"].string.isRequired,
    paletteMuted400: _propTypes["default"].string.isRequired,
    paletteMuted500: _propTypes["default"].string.isRequired,
    paletteMuted600: _propTypes["default"].string.isRequired,
    paletteMuted700: _propTypes["default"].string.isRequired
  })]),
  /**
   * An object of theme tokens imported from the Meridian token library.
   */
  tokens: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].string)]))
} : {};
var _default = Theme;
exports["default"] = _default;